<!-- updated-code  -->
<!-- this is home front view -->
<div class="available-rooms-wrapper" *ngIf="roomLocationStatus == 'roomFrontView'">
    <div class="available-rooms d-flex" *ngFor="let obj of roomResponseArrayModel.RoomLists; let roomIndex = index">
        <div class="row">
            <div class="col-lg-6 d-flex images-section">
                <div class="room-img-left">
                    <a [routerLink]="['/rooms',obj._id]">
                        <img [src]="obj.RoomImages[0]" alt=""
                            *ngIf="!globalService.validateIsEmpty(obj.RoomImages) && obj.RoomImages[0]; else  otherImage1" />
                        <ng-template #otherImage1>
                            <img src="assets/images/No_Image_Available.jpg" />
                        </ng-template>
                    </a>
                </div>
                <div class="room-img-right d-flex flex-column">
                    <div class="img-right-top">
                        <a [routerLink]="['/rooms',obj._id]">
                            <img [src]="obj.RoomImages[1]" alt=""
                                *ngIf="!globalService.validateIsEmpty(obj.RoomImages) && obj.RoomImages[1]; else  otherImage2" />
                            <ng-template #otherImage2>
                                <img src="assets/images/No_Image_Available.jpg" />
                            </ng-template>
                        </a>
                    </div>
                    <div class="img-right-bottom">
                        <a [routerLink]="['/rooms',obj._id]">
                            <img [src]="obj.RoomImages[2]" alt=""
                                *ngIf="!globalService.validateIsEmpty(obj.RoomImages) && obj.RoomImages[2]; else  otherImage3" />
                            <ng-template #otherImage3>
                                <img src="assets/images/No_Image_Available.jpg" />
                            </ng-template>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 room-detail-guest">
                <div class="row height-100">
                    <div class="col-lg-6">
                        <div class="room-desc">
                            <div class="d-flex flex-wrap room-bio">
                                <div class="about-room-img">
                                    <img [src]="obj.RoomImages[0]" alt=""
                                        *ngIf="!globalService.validateIsEmpty(obj.RoomImages) && obj.RoomImages[0]; else  otherImageMobile" />
                                    <ng-template #otherImageMobile>
                                        <img src="assets/images/No_Image_Available.jpg" />
                                    </ng-template>
                                </div>

                                <div class="about-room">
                                    <span class="font-20 medium-600 black">{{obj?.RoomNameLangs?.[0]?.Value}}</span>
                                    <div class="review d-flex align-item flex-wrap">
                                        <span
                                            class=" entire-appartment font-14 normal grey-darker-shade display-block">{{obj?.RoomType?.RoomTypeLangs?.[0]?.Value}}</span>
                                        <div class="d-flex align-item star width-100">
                                            <mat-icon class="star-icon">star</mat-icon>
                                            <span class="grey-darker-shade font-14 ml-1">4.94 ·107
                                                {{'reviews'|translate}} | {{'InclOfFreeBreakFast'|translate}}</span>
                                        </div>
                                    </div>
                                    <!-- <div class="executive-button">
                                        <span mat-raised-button color="">{{'ExecutiveRoom'|translate}}</button>
                                    </div> -->
                                </div>
                            </div>

                            <span
                                class="font-20 font-bold mt-3 display-block mobile-place-offers">{{'WhatThisPlaceOffers'|translate}}</span>
                            <div class=" d-flex hotel-offers">
                                <div class="place-offer">
                                    <ul>
                                        <li class="d-flex align-item mb-3"
                                            *ngFor="let data of getAmenitiesByRoom(obj, roomIndex)">
                                            <mat-icon>{{data?.AmenitiesIcon}}</mat-icon>
                                            <span
                                                class="ml-3 font-16 black medium-600">{{data.AmenitiesLangs.length>0?data.AmenitiesLangs[0].Value:data.AmenitiesIcon}}</span>
                                        </li>
                                    </ul>
                                    <button type="button" class="amenities-toggle" *ngIf="hasMoreAmenities(obj)"
                                        (click)="toggleAmenities(roomIndex)">
                                        {{expandedAmenities[roomIndex] ? 'Show less' : '+' + (obj.AmenitiNames.length - amenitiesLimit) + ' amenities'}}
                                    </button>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="room-prize d-flex flex-column">
                            <div>
                                <div class="cancellation-button d-flex align-item room-left"
                                    *ngIf="obj.Bookings.length > 0 && obj.RoomsNumber.length > 0">
                                    <span
                                        class="font-12 normal d-flex align-item justify-center pande">{{obj.RoomsNumber?.length
                                        == obj.Bookings?.length?searchData.location=='roomSearch'?'Fully booked till ' +
                                        checkout?.toString()?.slice(0,10) :'Fully booked till ' +
                                        showDate:obj.RoomsNumber.length >
                                        obj.Bookings.length?searchData.location=='roomSearch'?(obj.RoomsNumber.length -
                                        obj.Bookings.length) + ' room left' :(obj.RoomsNumber.length -
                                        obj.Bookings.length)
                                        + ' room left':searchData.location=='roomSearch'?'Fully booked till ' +
                                        checkout?.toString()?.slice(0,10) :'Fully booked till ' + showDate}}</span>
                                    <!---->
                                </div>
                                <div class="rooms-prize-deatil d-flex flex-column">
                                    <span class="font-16 normal cancellation">
                                        <span [innerHTML]="currencyLogo"></span> {{obj.RoomPriceNight | number: '1.2-2'
                                        }}</span>
                                    <span class="amount font-bold-large  mt-2">
                                        <span [innerHTML]="currencyLogo"></span> {{obj.RoomPriceNight | number: '1.2-2'
                                        }}</span>
                                    <span class="taxes font-13 normal">+ Taxes & Fees</span>
                                    <span class="fees font-13 normal">1 Room / Night</span>
                                </div>
                            </div>
                            <div class="end-section d-flex flex-column justify-content-between mt-2">
                                <div class="room-prize-buttons d-flex">
                                    <div class="book-now font-12 font-bold d-flex">
                                        <button mat-button class="d-flex align-item justify-center"
                                            [disabled]="obj.RoomsNumber.length == obj.Bookings.length || obj.RoomsNumber.length < obj.Bookings.length"
                                            (click)="bookNow(obj._id)"> <!--[routerLink]="['/rooms',obj._id]"-->
                                            {{'BookNow'|translate}}
                                        </button>
                                    </div>
                                </div>
                                <div class="cancellation-button d-flex align-item">
                                    <span class="font-12 normal pande">{{'FreeCancellationTill'|translate}} {{ today |
                                        date: 'dd MMM yyyy' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="pagination" *ngIf="!globalService.validateIsEmpty(roomResponseArrayModel.RoomLists)">
        <span *ngIf="roomResponseArrayModel.RoomLists.length">
            <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
            </mat-paginator>
        </span>
    </div>
</div>
<!-- updated-code end -->

<div *ngIf="roomLocationStatus=='noResultFound'">
    <div class="no-result-img no-result">
        <img class="" src="../../../../assets/images/no-results.png" alt="">
    </div>
    <h2 class="no-result mtb-2">{{'SorryNoResultFound'|translate}}(</h2>
    <p class="no-result">{{'WeAreSorryWhatYouLookingForPleasetryAnotherWay'|translate}}</p>
</div>



<!-- //Home Page -->
<div class="inner-loader" *ngIf="showLoader">
    <mat-progress-spinner class="tp-margin" [color]="color" [mode]="mode">
    </mat-progress-spinner>

</div>


<!-- Home list -->
<div class="home-page row" *ngIf="roomLocationStatus == 'home'">
    <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
        *ngFor="let obj of roomResponseArrayModel.RoomLists | slice:0:4;">
        <div class="wrapper-list-thumb home-page-card">
            <div class="img-info-on-hover">
                <button class="icon1" *ngIf="globalService.hasLoginInAuthToken()">
                    <mat-icon>favorite_border</mat-icon>
                </button>
                <div class="room-img-wrapper">
                    <a [routerLink]="['/rooms',obj._id]">
                        <img [src]="obj.RoomImages[0]" *ngIf="obj.RoomImages && obj.RoomImages[0];else  otherImage" />

                        <ng-template #otherImage>
                            <img src="assets/images/No_Image_Available.jpg" />

                        </ng-template>
                    </a>


                </div>
                <!-- <div class="img-overlay">
                    <div class="overlay-items mb-4">
                        <div class="overlay-btn mr-3">
                            <button mat-button [routerLink]="['/rooms',obj._id]">{{'BookNow'|translate}}</button>
                        </div>
                        <button class="icon1 mr-3">
                            <mat-icon>favorite_border</mat-icon>
                        </button>
                        <button class="icon2 mr-3">
                            <mat-icon [routerLink]="['/rooms',obj._id]">info</mat-icon>
                        </button>
                    </div>

                </div> -->
            </div>
            <div class="list-thumb-content">
                <div class="list-thumb-content-block">
                    <p class="type-info  secondary-text"
                        *ngIf="obj.RoomType && obj.RoomType.RoomTypeLangs && obj.RoomType.RoomTypeLangs.length;else otherRoomType">
                        {{ obj.RoomType.RoomTypeLangs[0].Value }}</p>

                    <ng-template #otherRoomType>
                        <p class="type-info  secondary-text">
                            {{ 'NotAvailable'|translate }}</p>
                    </ng-template>
                    <p class="title-info primary-text"
                        *ngIf="obj.RoomNameLangs && obj.RoomNameLangs.length;else otherRoomName">
                        {{ obj.RoomNameLangs[0].Value }}
                    </p>
                    <ng-template #otherRoomName>
                        <p class="title-info primary-text">
                            {{ 'NotAvailable'|translate }}
                        </p>
                    </ng-template>
                </div>
                <button mat-button [routerLink]="['/rooms',obj._id]"
                    *ngIf="globalService.hasLoginInAuthToken()">{{'BookNow'|translate}}</button>
            </div>
        </div>
    </div>

</div>
<!-- //Home list -->
<!-- Home Page Menu Page -->
<div class="home-page row" *ngIf="roomLocationStatus == 'homePageMenu'">
    <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
        *ngFor="let obj of roomResponseArrayModel.RoomLists">
        <div class="wrapper-list-thumb position-relative wrapper-list-thumb-manage">
            <div class="delete-image"> <i class="material-icons" (click)="deactivateFromHome(obj._id)"
                    [appAccessCheck]="'homepage-menu'" [givenButton]="'delete'">delete</i></div>
            <div class="room-img-wrapper">
                <img [src]="obj.RoomImages[0]" *ngIf="obj.RoomImages && obj.RoomImages[0];else  otherImage" />
                <ng-template #otherImage>
                    <img src="assets/images/No_Image_Available.jpg" />
                </ng-template>
            </div>
            <div class="list-thumb-content">
                <p class="type-info  secondary-text"
                    *ngIf="obj.RoomType && obj.RoomType.RoomTypeLangs && obj.RoomType.RoomTypeLangs.length;else otherRoomType">
                    {{ obj.RoomType.RoomTypeLangs[0].Value }}</p>

                <ng-template #otherRoomType>
                    <p class="type-info  secondary-text">
                        {{ 'NotAvailable'|translate }}</p>
                </ng-template>
                <p class="title-info primary-text"
                    *ngIf="obj.RoomNameLangs && obj.RoomNameLangs.length;else otherRoomName">
                    {{ obj.RoomNameLangs[0].Value }}
                </p>
                <ng-template #otherRoomName>
                    <p class="title-info primary-text">
                        {{ 'NotAvailable'|translate }}
                    </p>
                </ng-template>
            </div>
        </div>
    </div>
</div>


<!---Room Manage Page-->
<div class="room-manage-page row" *ngIf="roomLocationStatus == 'roomManagePage'">
    <!---->
    <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 col-xs-12"
        *ngFor="let obj of roomResponseArrayModel.RoomLists">
        <div class="wrapper-list-thumb">
            <div class="room-img-wrapper">
                <img [src]="obj.RoomImages[0]" *ngIf="obj.RoomImages && obj.RoomImages[0]; else otherImage" />
                <ng-template #otherImage>
                    <img src="assets/images/No_Image_Available.jpg" />
                </ng-template>
            </div>
            <div class="list-thumb-content">
                <p class="type-info  secondary-text"
                    *ngIf="obj.RoomType && obj.RoomType.RoomTypeLangs && obj.RoomType.RoomTypeLangs.length;else otherRoomType">
                    <!---->
                    {{ obj.RoomType.RoomTypeLangs[0].Value }}
                </p>

                <ng-template #otherRoomType>
                    <p class="type-info  secondary-text">
                        {{ 'NotAvailable'|translate }}</p>
                </ng-template>
                <p class="title-info primary-text"
                    *ngIf="obj.RoomNameLangs && obj.RoomNameLangs.length;else otherRoomName">
                    {{ obj.RoomNameLangs[0].Value }}
                </p>
                <ng-template #otherRoomName>
                    <p class="title-info primary-text">
                        {{ 'NotAvailable'|translate }}
                    </p>
                </ng-template>
            </div>
            <div class="button-section">
                <button class="btn btn-primary" type="button" (click)="detailRoomView(obj._id)"
                    [appAccessCheck]="'rooms'" [givenButton]="'view'"><i
                        class="material-icons">remove_red_eye</i>{{'ViewDetail'|translate}}</button>
                <button class="btn btn-secondary" type="button" (click)="editRoomView(obj._id)"
                    [appAccessCheck]="'rooms'" [givenButton]="'edit'"><i
                        class="material-icons">create</i>{{'Edit'|translate}}</button>
            </div>
        </div>
    </div>
    <div class="pagination" *ngIf="roomResponseArrayModel.RoomLists">
        <span *ngIf="roomResponseArrayModel.RoomLists.length">
            <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
            </mat-paginator>
        </span>
    </div>
</div>

<!---//Room Manage Page-->